import { DefaultService } from "./DefaultService";
import axios from "@/api/axios";

export default class extends DefaultService {
  entityUrl = "services";

  listServices(clinicId: any = null): Promise<any> {
    let urlParams = "";
    if (clinicId) {
      urlParams = `?clinicId=${clinicId}`;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}${urlParams}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
